export const mobile = 700
export const tablet = 1000
